<ng-container *transloco="let t">
  <pxw-modal-dialog
    [title]="t('removedCartItemsDialog.title')"
    [acceptText]="t('removedCartItemsDialog.acceptText')"
    [confirmText]="t('removedCartItemsDialog.confirmText')"
    [cancelText]="t('removedCartItemsDialog.cancelText')"
    [type]="dialogType()"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('removedCartItemsDialog.description') }}</p>
      <table class="cart-items-removed">
        <thead>
          <tr>
            <th class="category">{{ t('removedCartItemsDialog.category') }}</th>
            <th class="product">{{ t('removedCartItemsDialog.product') }}</th>
          </tr>
        </thead>
        <tbody>
          @for (removedCartItem of removedCartItems(); track removedCartItem.id) {
            <tr>
              <td class="category">
                <span>{{ removedCartItem.category.name }}</span>
              </td>
              <td class="product">
                <span>{{ removedCartItem.product.name }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
